import * as React from "react";
import { Translations } from "ui/Scripts/source/models/translations";
import { Base } from "ui/Scripts/source/framework/base";
import { SubPageHeader } from "../app/header";
import * as storeTypes from "../../models/store/storeTypes";
import * as documentService from "../../models/services/documentService";
import { customHistory } from "../../framework/customHistory";
import { Session } from "../../models/session/session";
import { ActivePageType, NavigationBar } from "../app/navigation";
import { DocumentListSearchDialog } from "./documentListSearch";
import { DocumentListLine } from "./documentListLine";
import { IDocumentListItem, IDocumentListParentItem } from "../../models/document/documentListItem";
import { RouteComponentProps } from "react-router";
import { DocumentListParentLine } from "./documentListParentLine";
import { SaveDataObj } from "../../framework/saveData";
import { ConfirmationDialogResult, Permission } from "ui/Scripts/source/models/enums";
import { CameraPhoto } from "../framework/cameraPhoto";
import { DocumentListCompanyLine } from "./documentListCompanyLine";
import { IDocumentCompanyListItem } from "../../models/document/documentCompanyListItem";
import IUserState = storeTypes.IUserState;
import { FileAttachment } from "ui/Scripts/source/models/common/fileAttachment";
import { AppUtils } from "../../framework/appUtils";
import { ConfirmationDialogType } from "../../models/store/storeTypes";
import { SaveAttachmentBase64 } from "../../../../../QTeamSystems.QTeamIntra.Ui/Scripts/source/models/common/saveAttachmentBase64";

//DocumentListMenu
export interface IDocumentListMenuProp {
    item: IDocumentListItem;
    favoriteIds: string[];
    onDownload: () => void;
    onViewContent: () => void;
    onRemove: () => void;
    onAddToFavorites: () => void;
    onRemoveFromFavorites: () => void;
    onCancel: () => void;
}

export class DocumentListMenu extends React.Component<IDocumentListMenuProp, {}> {
    handleDownload = (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.props.onDownload();
    };

    handleViewContent = (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.props.onViewContent();
    };

    handleRemove = (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.props.onRemove();
    };

    handleAddToFavorites = (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.props.onAddToFavorites();
    };

    handleRemoveFromFavorites = (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.props.onRemoveFromFavorites();
    };

    handleCancel = (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.props.onCancel();
    };
        
    render() {
        const item = this.props.item;
        const isFavorite = item.isFolder && this.props.favoriteIds.indexOf(item.id) > -1;
        return (
            <div className="listPopupMenu" onClick={this.handleCancel}>
                <div className="menu">
                    {!item.isFolder && !!item.documentVersionId &&
                        <div className="line" onClick={this.handleViewContent}>{Translations.Open}</div>
                    }
                    {!item.isFolder &&
                        <div className="line" onClick={this.handleDownload}>{Translations.Download}</div>
                    }
                    {!item.isFolder && !Base.isNullOrUndefined(this.props.onRemove) &&
                        <div className="line" onClick={this.handleRemove}>{Translations.Remove}</div>
                    }
                    {item.isFolder && !isFavorite &&
                        <div className="line" onClick={this.handleAddToFavorites}>{Translations.AddToFavorites}</div>
                    }
                    {item.isFolder && isFavorite &&
                        <div className="line" onClick={this.handleRemoveFromFavorites}>{Translations.RemoveFromFavorites}</div>
                    }
                    <div className="line" onClick={this.handleCancel}>{Translations.Cancel}</div>
                </div>
            </div>
        );
    }
}

//DocumentList
export interface IDocumentListOwnProps {
}

export interface IDocumentListStateProps {
    user: IUserState;
    hasMore: boolean;
    isLoading: boolean;
    page: number;
    companyId: string;
    parent: IDocumentListParentItem;
    items: IDocumentListItem[];
    favoriteIds: string[];
    companies: IDocumentCompanyListItem[];
    filter: string;
    sortColumn: string;
    sortOrderIsAsc: boolean;
    lastOpenedDocumentId: string;
}

export interface IDocumentListDispatchProps {
    loadDocuments: (folderId: string, companyId: string, page: number, filter: string, sortColumn: string, sortOrderIsAsc: boolean) => void;
    searchDocuments: (folderId: string, companyId: string, page: number, filter: string, sortColumn: string, sortOrderIsAsc: boolean) => void;
    resetDocuments: () => void;
    setLastOpenedDocumentId: (id: string) => void;
    setReturnUrl: (url: string) => void;
    addFavorite: (id: string, companyId: string) => void;
    removeFavorite: (id: string, companyId: string) => void;
    onLogout: () => void;
}

export interface IDocumentListPathProps {
    folderId: string;
    companyId: string;
}

type DocumentListProp = IDocumentListOwnProps & IDocumentListStateProps & IDocumentListDispatchProps & RouteComponentProps<IDocumentListPathProps>;

interface IDocumentListState {
    selectedId: string;
    showListMenu: boolean;
    showSearchDialog: boolean;
    listMenuItem: IDocumentListItem;
    companyName: string;
    cameraIds: string[];
    showCamera: boolean;
    showingCamera: boolean;
    searchInUse: boolean;
}

export class DocumentList extends React.Component<DocumentListProp, IDocumentListState> {
    private containerDiv: HTMLDivElement;
    private scrollToTop: boolean;
    private scrollToTopFolderId: string;
    private defaultSortColumn = "date";
    private defaultSortOrderIsAsc = false;

    constructor(props: DocumentListProp) {
        super(props);
        this.scrollToTop = false;
        this.scrollToTopFolderId = "";
        this.state = {
            selectedId: "",
            showListMenu: false,
            showSearchDialog: false,
            listMenuItem: null,
            companyName: "",
            cameraIds: [],
            showCamera: false,
            showingCamera: false,
            searchInUse: false
        };
    }

    handleParentLineLongPress = (id: string) => {
        const listMenuItem = this.props.parent;
        if (!listMenuItem) return;
        this.setState({
            showListMenu: true,
            listMenuItem
        });
    };

    handleLineLongPress = (id: string) => {
        const listMenuItem = this.props.items.find(i => i.id === id);
        if (!listMenuItem) return;
        this.setState({
            selectedId: id,
            showListMenu: true,
            listMenuItem
        });
    };

    handleRefreshList = () => {
        const props = this.props;
        props.loadDocuments(props.match.params.folderId, props.companyId, 1, "", props.sortColumn, props.sortOrderIsAsc);
        this.setState({
            searchInUse: false
        });
    };

    scrollToLastOpenedDocument = (): boolean => {
        const props = this.props;
        let result = false;
        if (props.items.length > 0 && props.lastOpenedDocumentId) {
            if (this.containerDiv.scrollTo !== null && this.containerDiv.scrollTo !== undefined) {
                const index = props.items.findIndex(i => i.id === props.lastOpenedDocumentId);
                if (index > -1) {
                    const elements = this.containerDiv.getElementsByClassName("lod");
                    if (elements.length > 0 && elements[0]) {
                        const y = (elements[0] as HTMLDivElement).offsetTop;
                        this.containerDiv.scrollTo({
                            top: y,
                            left: 0,
                            behavior: "auto"
                        });
                        this.scrollToTopFolderId = "";
                        result = true;
                    }
                }
            }
            this.props.setLastOpenedDocumentId("");
        }
        return result;
    };

    componentDidMount(): void {
        const props = this.props;
        props.loadDocuments(props.match.params.folderId, props.match.params.companyId, 1, "", props.sortColumn, props.sortOrderIsAsc);
        //Set cameras
        Base.getCameraIds()
            .then(ids => {
                this.setState({ cameraIds: ids });
            }).catch(() => {
                this.setState({ cameraIds: [] });
            });
        //Set companyName
        Session.getCompanyName()
            .then((companyName) => {
                this.setState({
                    companyName
                });
            });
        //Scroll last opened item to view
        this.scrollToLastOpenedDocument();
    }

    scrollToTopElement = () => {
        if (!this.containerDiv.scrollTo) {
            this.containerDiv.scrollTop = 0;
            this.containerDiv.scrollLeft = 0;
        } else {
            this.containerDiv.scrollTo(0, 0);
        }
        this.scrollToTop = false;
        this.scrollToTopFolderId = "";
    };

    componentDidUpdate(prevProps: DocumentListProp, prevState: IDocumentListState, snapshot: any): void {
        const props = this.props;
        if (prevProps.match.params.folderId !== props.match.params.folderId) {
            props.loadDocuments(this.props.match.params.folderId, props.match.params.companyId, 1, "", props.sortColumn, props.sortOrderIsAsc);
            this.setState({
                selectedId: "",
                searchInUse: false
            });
            this.scrollToTop = true;
            this.scrollToTopFolderId = props.match.params.folderId;
        } else {
            if (this.scrollToTop && props.parent && this.scrollToTopFolderId === props.parent.id) {
                this.scrollToTopElement();
            }
        }
    }

    componentWillUnmount(): void {
        this.props.resetDocuments();
    }

    handleBackClick = (parentId: string) => {
        customHistory.push("/document/" + parentId + "/" + this.props.companyId);
    };

    handleLineClick = (id: string, isFolder: boolean) => {
        if (isFolder) {
            this.props.setLastOpenedDocumentId(id);
            customHistory.push("/document/" + id + "/" + this.props.companyId);
        } else {
            this.setState({
                selectedId: id
            });
        }
    };

    handleCompanyLineClick = (id: string, companyId: string) => {
        this.props.setLastOpenedDocumentId(id);
        customHistory.push("/document/" + id + "/" + companyId);
    };

    handleDownload = async (id: string, companyId: string) => {
        if (!id || !companyId) return;
        const fileName = await AppUtils.callService(() => documentService.downloadDocument(id, companyId));
        if (!fileName) return;
        AppUtils.showSuccessMessage(String.format(Translations.DocumentParameterDownloaded, fileName));
    };

    setReturnUrl = () => {
        const props = this.props;
        props.setReturnUrl("/document/" + props.match.params.folderId + "/" + props.companyId);
    };

    handleViewContent = (id: string, companyId: string, documentVersionId: string) => {
        if (!id || !companyId || !documentVersionId) return;
        this.props.setLastOpenedDocumentId(id);
        this.setReturnUrl();
        customHistory.push("/documentversion/" + documentVersionId + "/" + companyId);
    };

    handleMenuViewContent = () => {
        const listMenuItem = this.state.listMenuItem;
        if (!listMenuItem) return;
        this.setState({
            showListMenu: false
        });
        this.handleViewContent(listMenuItem.id, this.props.companyId, listMenuItem.documentVersionId);
    };

    handleMenuDownload = () => {
        const listMenuItem = this.state.listMenuItem;
        if (!listMenuItem) return;
        this.setState({
            showListMenu: false
        });
        this.handleDownload(listMenuItem.id, this.props.companyId);
    };

    handleMenuRemove = async () => {
        const props = this.props;
        const listMenuItem = this.state.listMenuItem;
        if (!listMenuItem) return;
        this.setState({
            showListMenu: false
        });
        const confirmationResult = await AppUtils.showConfirmationDialog(String.format(Translations.DoYouReallyWantToRemoveFileParameter, listMenuItem.code), false, ConfirmationDialogType.Warning, Translations.RemoveFile);
        if (confirmationResult !== ConfirmationDialogResult.Yes) return;
        const result = await AppUtils.callService(() => documentService.removeFile(listMenuItem.id, props.companyId));
        if (!result) return;
        this.handleRefreshList();
    };

    handleAddToFavorites = () => {
        const props = this.props;
        const listMenuItem = this.state.listMenuItem;
        if (!listMenuItem) return;
        this.setState({
            showListMenu: false
        });
        props.addFavorite(listMenuItem.id, props.companyId);
    };

    handleRemoveFromFavorites = () => {
        const props = this.props;
        const listMenuItem = this.state.listMenuItem;
        if (!listMenuItem) return;
        this.setState({
            showListMenu: false
        });
        props.removeFavorite(listMenuItem.id, props.companyId);
    };

    handleMenuCancel = () => {
        this.setState({
            showListMenu: false
        });
    };

    handleSearchMessages = () => {
        this.setState({
            showSearchDialog: true
        });
    };

    handleSearchDialogOk = (filter: string, sortColumn: string, sortOrderIsAsc: boolean) => {
        const props = this.props;
        this.setState({
            showSearchDialog: false,
            searchInUse: true
        });
        props.searchDocuments(props.match.params.folderId, props.companyId, 1, filter, sortColumn, sortOrderIsAsc);
    };

    handleSearchDialogClear = () => {
        const props = this.props;
        this.setState({
            showSearchDialog: false,
            searchInUse: false
        });
        props.loadDocuments(props.match.params.folderId, props.companyId, 1, "", this.defaultSortColumn, this.defaultSortOrderIsAsc);
    };

    handleSearchDialogCancel = () => {
        this.setState({
            showSearchDialog: false
        });
    };

    //#region File
    addFiles = async (directoryItemId: string, files: FileAttachment[]) => {
        //Set save data
        const saveData = new SaveDataObj();
        saveData.append("id", directoryItemId);
        saveData.append("companyId", this.props.companyId);
        const attachments: SaveAttachmentBase64[] = [];
        const lastModifieds: number[] = [];
        for (const fileAttachment of files.filter(i => !!i.file)) {
            const attachment = await SaveAttachmentBase64.fromFileAttachment("", fileAttachment);
            if (!attachment) continue;
            attachments.push(attachment);
            lastModifieds.push(fileAttachment.file.lastModified);
        }
        saveData.append("attachments", attachments);
        saveData.append("lastModifieds", lastModifieds);
        //Call server
        const result = await AppUtils.callService(() => documentService.addFiles(saveData.obj));
        if (!result) return;
        this.handleRefreshList();
    };

    handleAddFile = (fileList: FileList, closeNavigationMenu: () => void) => {
        const obj = this;
        if (Base.isNullOrUndefined(this.props.parent) || this.props.parent.permission < Permission.Edit) return;
        FileAttachment.addFileListToFileAttachments([], fileList, 0).then(files => {
            if (closeNavigationMenu) {
                closeNavigationMenu();
            }
            obj.addFiles(this.props.parent.id, files);
        });
    };
    //#endregion File

    //#region Camera
    hasCameras = (): boolean => {
        const state = this.state;
        return state.cameraIds && state.cameraIds.length > 0;
    };

    handleCameraStreamAvailable = () => {
        this.setState({ showingCamera: true });
    };

    handleAddPhoto = () => {
        if (!this.hasCameras()) return;
        this.setState({ showCamera: true });
    };

    handleCameraPhotoOk = async (dataUrl: string) => {
        const props = this.props;
        this.setState({ showCamera: false, showingCamera: false });
        if (!props.parent || props.parent.permission < Permission.Edit) return;
        const file = await FileAttachment.photoToFileAttachment(dataUrl, 0);
        if (!file) return;
        this.addFiles(props.parent.id, [file]);
    };

    handleCameraPhotoCancel = (permissionDenied: boolean) => {
        if (!permissionDenied) {
            this.setState({ showCamera: false, showingCamera: false });
        } else {
            this.setState({ showCamera: false, showingCamera: false, cameraIds: [] });
        }
    };
    //#endregion Camera
    
    getListTitleSuffix = (filter: string, sortColumn: string, sortOrderIsAsc: boolean) => {
        let result = "";
        if (filter) {
            result = result + filter;
        }
        if (result) {
            result = " - " + result;
        }
        return result;
    };

    render() {
        const props = this.props;
        const activeCompany = props.companies.find(i => i.id === props.companyId);
        const permission = !Base.isNullOrUndefined(props.parent) ? props.parent.permission : 0;
        const firstIndex = props.items.length > 0 ? props.items.findIndex(i => !i.isTitle) : -1;
        const nowDate = Date.now();
        const oneHourInMs = 60 * 60 * 1000;
        const hasCameras = this.hasCameras();
        const showCamera = hasCameras && this.state.showCamera;
        const showingCamera = showCamera && this.state.showingCamera;
        return (
            <div>
                {!showingCamera &&
                    <div className="pageContentContainer">
                        <div className="documentListContainer mainListContainer" ref={(elem) => { this.containerDiv = elem; }}>
                            <div className="lineContainer mainLineContainer documentList">
                                {props.companies.length > 1 && !Base.isNullOrUndefined(activeCompany) &&
                                    <DocumentListCompanyLine
                                        key={activeCompany.id}
                                        item={activeCompany}
                                        onClick={this.handleCompanyLineClick}
                                    />
                                }
                                {!Base.isNullOrUndefined(props.parent) &&
                                    <DocumentListParentLine
                                        key={props.parent.id}
                                        companyId={props.companyId}
                                        classes={"parentFolder"}
                                        item={props.parent}
                                        favorite={props.favoriteIds.indexOf(props.parent.id) > -1}
                                        onBackClick={this.handleBackClick}
                                        onLongPress={this.handleParentLineLongPress}
                                        onRemoveFavorite={props.removeFavorite}
                                    />
                                }
                                {props.items.map((item, index) => (
                                    <DocumentListLine
                                        key={item.id}
                                        companyId={props.companyId}
                                        item={item}
                                        selected={this.state.selectedId === item.id}
                                        favorite={item.isFolder && props.favoriteIds.indexOf(item.id) > -1}
                                        first={index === firstIndex}
                                        recentlyUpdated={(nowDate - item.modifyDate) <= oneHourInMs}
                                        isLastOpenedDocument={item.id === props.lastOpenedDocumentId}
                                        onClick={this.handleLineClick}
                                        onLongPress={this.handleLineLongPress}
                                        onRefreshList={this.handleRefreshList}
                                        onRemoveFavorite={props.removeFavorite}
                                        onDownload={this.handleDownload}
                                        onViewContent={this.handleViewContent}
                                    />
                                ))}
                                {props.companies.length > 1 &&
                                    <div className="line empty"><span className="icon spacer"></span></div>
                                }
                                {props.companies.filter(i => i.id !== props.companyId).map((company) => (
                                    <DocumentListCompanyLine
                                        key={company.id}
                                        item={company}
                                        onClick={this.handleCompanyLineClick}
                                    />
                                ))}
                            </div>
                        </div>
                    </div>
                }
                {!showingCamera && this.state.showListMenu &&
                    <DocumentListMenu
                        item={this.state.listMenuItem}
                        favoriteIds={props.favoriteIds}
                        onDownload={this.handleMenuDownload}
                        onViewContent={this.handleMenuViewContent}
                        onRemove={permission < Permission.Edit ? null : this.handleMenuRemove}
                        onAddToFavorites={this.handleAddToFavorites}
                        onRemoveFromFavorites={this.handleRemoveFromFavorites}
                        onCancel={this.handleMenuCancel}
                    />
                }
                {!showingCamera && this.state.showSearchDialog &&
                    <DocumentListSearchDialog
                        filter={props.filter}
                        sortColumn={props.sortColumn}
                        sortOrderIsAsc={props.sortOrderIsAsc}
                        onOk={this.handleSearchDialogOk}
                        onClear={this.handleSearchDialogClear}
                        onCancel={this.handleSearchDialogCancel}
                    />
                }
                {!showingCamera &&
                    <NavigationBar
                        activePage={ActivePageType.Document}
                        user={props.user}
                    />
                }
                {!showingCamera &&
                    <SubPageHeader
                        user={props.user}
                        title={Translations.Documents + this.getListTitleSuffix(props.filter, props.sortColumn, props.sortOrderIsAsc)}
                        searchIsSet={this.state.searchInUse}
                        onSearch={this.handleSearchMessages}
                        onAddFile={permission > Permission.Read ? fileList => this.handleAddFile(fileList, null) : null}
                        onAddPhoto={permission > Permission.Read && hasCameras ? this.handleAddPhoto : null}
                    />
                }
                {showCamera &&
                    <CameraPhoto
                        cameraIds={this.state.cameraIds}
                        cameraStreamAvailable={this.state.showingCamera}
                        onCameraStreamAvailable={this.handleCameraStreamAvailable}
                        onOkClick={this.handleCameraPhotoOk}
                        onCancelClick={this.handleCameraPhotoCancel}
                    />
                }
            </div>
        );
    }
}